import * as actionTypes from '../actionTypes'

export const timeElapse = () => dispatch => dispatch({type: actionTypes.TIME_ELAPSE})

export const changeStage = (stage, time) => dispatch => {
    dispatch({type: actionTypes.TIME_RESET, time})
    dispatch({type: actionTypes.CHANGE_STAGE, stage})
}

export const updateConfig = (config) => dispatch => dispatch({type: actionTypes.UPDATE_CONFIG, config})